"use strict";

import onInitModulesInsScope from "./../onInitModulesInScope";
import initModulesInScope from "@elements/init-modules-in-scope";

export function init() {
    onInitModulesInsScope(function initInScope($scope) {
        let $rowLists = $scope.find('.js-row-list__wrapper');

        $rowLists.each(function () {
            let $rowList = $(this);
            let $lastId = $rowList.find('.js-row-list__item').last().find('.js-row-list__item__id').attr("id");
            let $newId = $lastId ? (parseInt($lastId) + 1) : 1;
            let $addButton = $rowList.closest('form').find('.js-row-list--add');
            let $deleteButtons = $('.js-row-list--delete');
            let $safeButtons = $('.js-row-list__safe');

            $addButton.on('click', function (evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                let $template = $($rowList.find('.js-row-list__template').html());
                let $templateNew = $template.clone();
                
                $templateNew.find('.js-row-list__item__id').attr("id", $newId);
                $templateNew.find('.js-row-list--delete').on('click', deleteItem);
                $newId++;

                $templateNew.find('.js-row-list__form-item').each(function (index) {
                    let $itemInput = $(this).find('.js-row-list__input');
                    let $itemLabel = $(this).find('.js-row-list__label');
                    let itemName = $itemInput.attr('name');

                    $itemLabel.attr('for', itemName+'-'+$newId);
                    $itemInput.attr('id', itemName+'-'+$newId);
                    $itemInput.attr('name', `news[${$newId}][${itemName}]`);
                });

                $rowList.append($templateNew);
                initModulesInScope($rowList.parent());
            });

            $deleteButtons.on('click', deleteItem);

            function deleteItem() {
                let removeId = $(this).closest('.js-row-list__item').find('.js-row-list__item__existingId').val();
                $(this).closest('.js-row-list__item').remove();

                if(removeId) {
                    $rowList.closest('form').find('.js-row-list--deleted-items').append(renderResultItem(removeId));
                }
            }

            $safeButtons.on('click', function() {
                let $btn = $(this);
                let $item = $btn.closest('.js-row-list__item');
                let $loadingEl = $item.find('.js-row-list__loading');
                let $errorEl = $scope.find('.js-form-show-error');
                let $successEl = $scope.find('.js-form-show-success');
                let formdata = new FormData();
                let formAction = $btn.attr('data-row-list-save-url');

                $item.find('.js-row-list__input').each(function() {
                    formdata.append($(this).attr('name'), $(this).val());
                });
                formdata.append('checkModification', $(this).data('check-modification'));

                $loadingEl.removeAttr('hidden');

                $.ajax(formAction, {
                    method: 'POST',
                    data: formdata,
                    contentType: false,
                    processData:false,
                    enctype: 'multipart/form-data',
                }).done(function (response) {
                    if (response.success && response.showModal) {
                        let reloadBtn = $('#overrideModal').find('.js-modal__reload');
                        let overrideBtn = $('#overrideModal').find('.js-modal__override');

                        $('#overrideModal').modal('show');
                        reloadBtn.click(function () {
                            location.reload();
                        });

                        overrideBtn.click(function (e) {
                            e.stopImmediatePropagation();
                            $('#overrideModal').modal('hide');

                            $.ajax(formAction, {
                                method: 'POST',
                                data: formdata,
                                contentType: false,
                                processData:false,
                                enctype: 'multipart/form-data',
                            }).done(function (response) {
                                if (response.success) {
                                    if (response.html) {
                                        handleDbUpdateResponse(response, $item, $rowList, $loadingEl, $successEl);
                                    }
                                } else {
                                    $loadingEl.attr('hidden', true);
                                    $errorEl.attr('hidden', false);
                                }
                            }).fail(function () {
                                $loadingEl.attr('hidden', true);
                                $errorEl.attr('hidden', false);
                            });
                        });
                    } else if (response.success) {
                        handleDbUpdateResponse(response, $item, $rowList, $loadingEl, $successEl);
                    } else {
                        $loadingEl.attr('hidden', true);
                        $errorEl.attr('hidden', false);
                    }
                }).fail(function () {
                    $loadingEl.attr('hidden', true);
                    $errorEl.attr('hidden', false);
                });
            })
        });

        function renderResultItem(elementId) {
            return `<input type='hidden' name="remove-news[]" value="${elementId}">`;
        }

        function handleDbUpdateResponse(response, $item, $rowList, $loadingEl, $successEl) {
            $item.empty().append(response.html);
            initModulesInScope($rowList.parent());
            $loadingEl.attr('hidden', true);
            $successEl.attr('hidden', false);
        }
    })
}